export default "__VITE_ASSET__yLq6mOdu__"